import { pathPrefix } from 'src/util';
import { actionTypes } from "./constants";
const initialState = {
  isMobile: false,
  isWideScreen: true,
  message: null,
  curUrl: {
    url: pathPrefix + '/login',
    state: null,
  },
  provinceList: [],
  cityList: [],
  countyList: [],
  cityListArray: [],
  countyListArray: [],
  curMenu: 0,
  interMenuIndex: 0,

  isList: true,
  isSolutionList: true,
  currTime: null,
  authMaterialList: [],
  currMenuPath: pathPrefix + "/main/index",
  searchGlobal: {},
  allDept: [],
  userByDept: {
    count: 0,
    rows: [],
  },
  befourLoginUrl: '',
};

const setCityListArray = (state, data, index) => {
  const cityListArray = [...state.cityListArray];
  cityListArray[index] = data;
  return cityListArray;
};

const setCountyListArray = (state, data, index) => {
  const countyListArray = [...state.countyListArray];
  countyListArray[index] = data;
  return countyListArray;
};

const clearAreaListArray = (state, data, index, type) => {
  if (isNaN(index)) {
    return [];
  }

  if (type === 'city') {
    const cityListArray = [...state.cityListArray];
    cityListArray.splice(index, 1);
    return cityListArray;
  }

  if (type === 'county') {
    const countyListArray = [...state.countyListArray];
    countyListArray.splice(index, 1);
    return countyListArray;
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_ISMOBILE:
      return {
        ...state, isMobile: action.data,
      };
    case actionTypes.SET_MESSAGE:
      return {
        ...state, message: action.data,
      };
    case actionTypes.SET_CURMENU:
      return {
        ...state, curMenu: action.data,
      };
    case actionTypes.SET_CURURL:
      return {
        ...state, curUrl: action.data,
      };
    case actionTypes.SET_PROVINCE:
      return {
        ...state, provinceList: action.data,
      };
    case actionTypes.SET_CITY:
      return {
        ...state, cityList: action.data,
      };
    case actionTypes.SET_COUNTY:
      return {
        ...state, countyList: action.data,
      };
    case actionTypes.SET_INTER_MENU_INDEX:
      return {
        ...state, interMenuIndex: action.data,
      };
    case actionTypes.SET_IS_WIDE_SCREEN:
      return {
        ...state, isWideScreen: action.data,
      };
    case actionTypes.SET_CITY_LIST_ARRAY:
      return {
        ...state, cityListArray: setCityListArray(state, action.data, action.index),
      };
    case actionTypes.SET_COUNTY_LIST_ARRAY:
      return {
        ...state, countyListArray: setCountyListArray(state, action.data, action.index),
      };
    case actionTypes.CLEAR_COUNTY_LIST_ARRAY:
      return {
        ...state, cityListArray: clearAreaListArray(state, action.data, action.index, 'city'), countyListArray: clearAreaListArray(state, action.data, action.index, 'county'),
      };
    case actionTypes.TOGGLE_LIST_SHOW:
      return {
        ...state, isList: action.data
      };
    case actionTypes.TOGGLE_SOLUTION_LIST_SHOW:
      return {
        ...state, isSolutionList: action.data
      };
    case actionTypes.SET_CURRENT_TIME:
      return {
        ...state, currTime: action.data,
      };
    case actionTypes.SET_AUTH_MATERIAL_LIST:
      return {
        ...state, authMaterialList: action.data,
      };
    case actionTypes.SET_CURR_MENU_PATH:
      return {
        ...state, currMenuPath: action.data,
      };
    case actionTypes.SET_SEARCH_GLOBAL:
      return {
        ...state, searchGlobal: action.data,
      };
    case actionTypes.SET_ALL_DEPT:
      return {
        ...state, allDept: action.data,
      };
    case actionTypes.SET_USER_BY_DEPT:
      return {
        ...state, userByDept: action.data,
      };
    case actionTypes.SET_BEFOUR_LOGIN_URL:
      return {
        ...state, befourLoginUrl: action.data,
      };
    default:
      return state;
  }
};